module.exports = __webpack_public_path__ + "img/TripCreator_addtrip_ss.866ada8c.png";